import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export type AppRole = "client" | "advisor" | "admin";

export function useRoles() {
  const { user, loading: authLoading } = useAuth();
  const [roles, setRoles] = useState<AppRole[] | null>(null);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { setRoles([]); return; }
    let cancelled = false;
    supabase.from("user_roles").select("role").eq("user_id", user.id).then(({ data, error }) => {
      if (cancelled) return;
      if (error) { setRoles([]); return; }
      setRoles((data ?? []).map((r) => r.role as AppRole));
    });
    return () => { cancelled = true; };
  }, [user, authLoading]);

  return {
    roles,
    loading: authLoading || roles === null,
    isAdmin: !!roles?.includes("admin"),
    isAdvisor: !!roles?.includes("advisor"),
    isClient: !!roles?.includes("client"),
  };
}